var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRepetitionWeekly(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.77981 12H7.73981L6.62781 8.032H7.63581L8.28381 10.72L8.98781 8.032H10.0118L10.7158 10.72L11.3638 8.032H12.3718L11.2598 12H10.2278L9.49981 9.168L8.77981 12Z",
    fill: "#312F2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8058 6.04917L12.9382 7.91671L17.4167 7.91671V3.43825L15.9442 4.91075C15.2133 3.88233 14.247 3.04369 13.126 2.46485C12.0049 1.88601 10.7617 1.58377 9.50001 1.58337C5.67626 1.58337 2.47792 4.30671 1.74167 7.91671H3.36459C4.07709 5.18546 6.55501 3.16671 9.50001 3.16671C10.5545 3.16737 11.5921 3.43137 12.5186 3.93474C13.4452 4.43811 14.2313 5.16491 14.8058 6.04917ZM6.0618 11.0834H1.58334V15.5618L3.05584 14.0893C3.7867 15.1178 4.75299 15.9564 5.87403 16.5352C6.99508 17.1141 8.23834 17.4163 9.50001 17.4167C13.3238 17.4167 16.5221 14.6934 17.2583 11.0834H15.6354C14.9229 13.8146 12.445 15.8334 9.50001 15.8334C8.44544 15.8327 7.40774 15.5687 6.48106 15.0653C5.55439 14.562 4.76807 13.8352 4.19346 12.9509L6.0618 11.0834Z",
    fill: "#312F2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepetitionWeekly);
export default __webpack_public_path__ + "static/media/RepetitionWeekly.bde75c75.svg";
export { ForwardRef as ReactComponent };